angular.module('picmonicng').filter('userHasBadge', function () {
  return function (input, badgeType) {
    var i = 0,
      len = input.length;
    for (; i < len; i++) {
      if (input[i]['badge'] == badgeType) {
        return true;
      }
    }
    return false;
  };
});
